// extracted by mini-css-extract-plugin
export default {"color_icon":"Table_color_icon__xHD9a","main_table":"Table_main_table__v86-1"};